import { render, staticRenderFns } from "./SearchTaskModal.vue?vue&type=template&id=494480ca&"
import script from "./SearchTaskModal.vue?vue&type=script&lang=ts&"
export * from "./SearchTaskModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports